import { render, staticRenderFns } from "./AppSidebarLinkGroup.vue?vue&type=template&id=36cc4306"
import script from "./AppSidebarLinkGroup.vue?vue&type=script&lang=js"
export * from "./AppSidebarLinkGroup.vue?vue&type=script&lang=js"
import style0 from "./AppSidebarLinkGroup.vue?vue&type=style&index=0&id=36cc4306&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports